import { z } from 'zod'

export const createStudyTagSchema = z.object({
  tag_id: z.string().regex(/^\([0-9A-Fa-f]{4},[0-9A-Fa-f]{4}\)$/, {
    message: 'Tag ID must be in the format (XXXX,XXXX) where X is a hexadecimal digit',
  }),
  tag_name: z.string().min(1, { message: 'Tag name is required' }),
  value_representation_id: z.string().min(1, { message: 'Value representation is required' }),
})

export const newDicomValueSchema = z.object({
  newValue: z.string().min(1, { message: 'New value is required' }),
  applyToAll: z.string().optional(),
})
